import ContentLoader from 'react-content-loader'
import type {UnnormalizedProps as UnnormalizedStyleProps} from '@yosmanyga/core-style'
import {SpacialFn, styled} from '@yosmanyga/web-style'
import {CirclePlaceholderProps} from '@yosmanyga/primitive-ui-spec'

export const CirclePlaceholder = ({
    width, height, color, background
}: CirclePlaceholderProps & UnnormalizedStyleProps) => {
    width = ((SpacialFn.normalizeWidth(width))?.def || 50) as number;
    height = ((SpacialFn.normalizeHeight(height))?.def || 50) as number;

    return <ContentLoader
        width={width}
        height={height}
        foregroundColor={color}
        backgroundColor={background as string}
    >
        <circle cx={width / 2} cy={height / 2} r={width / 2}/>
    </ContentLoader>
}

const StyledCirclePlaceholder = styled(CirclePlaceholder)`
    ${({margin}) => SpacialFn.compileMargin(SpacialFn.normalizeMargin(margin))}
`

export default StyledCirclePlaceholder
